"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@emotion/react");

const classes = {
  inputFile: {
    display: 'none'
  },
  containerAgregarFotos: {
    textAlign: 'center',
    marginBottom: 20
  },
  fotosContainer: {
    margin: '10px 0px 20px 0px',
    display: 'grid',
    gridGap: 24,
    gridTemplateColumns: '1fr 1fr 1fr',
    "@media screen and (max-width: 600px)": {
      gridTemplateColumns: 'auto',
      gridGap: 0
    }
  },
  emptyStateContainer: theme => /*#__PURE__*/(0, _react.css)("text-align:center;margin-bottom:", theme.spacing(2), ";margin-top:", theme.spacing(2), ";height:250px;" + (process.env.NODE_ENV === "production" ? "" : ";label:emptyStateContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRlcy9Gb3JtQWxidW0vc3R5bGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0J1QyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50ZXMvRm9ybUFsYnVtL3N0eWxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBjbGFzc2VzID0ge1xuICAgIGlucHV0RmlsZToge1xuICAgICAgICBkaXNwbGF5OiAnbm9uZScsXG4gICAgfSxcbiAgICBjb250YWluZXJBZ3JlZ2FyRm90b3M6e1xuICAgICAgICB0ZXh0QWxpZ246ICdjZW50ZXInLFxuICAgICAgICBtYXJnaW5Cb3R0b206IDIwLFxuICAgIH0sXG4gICAgZm90b3NDb250YWluZXI6e1xuICAgICAgICBtYXJnaW46ICcxMHB4IDBweCAyMHB4IDBweCcsXG4gICAgICAgIGRpc3BsYXk6ICdncmlkJyxcbiAgICAgICAgZ3JpZEdhcDogMjQsXG4gICAgICAgIGdyaWRUZW1wbGF0ZUNvbHVtbnM6ICcxZnIgMWZyIDFmcicsXG4gICAgICAgIFwiQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogNjAwcHgpXCI6IHtcbiAgICAgICAgICAgIGdyaWRUZW1wbGF0ZUNvbHVtbnM6ICdhdXRvJyxcbiAgICAgICAgICAgIGdyaWRHYXA6IDAsXG4gICAgICAgIH0sXG4gICAgfSxcbiAgICBlbXB0eVN0YXRlQ29udGFpbmVyOiAodGhlbWUpID0+IGNzc2BcbiAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3RoZW1lLnNwYWNpbmcoMil9O1xuICAgICAgICBtYXJnaW4tdG9wOiAke3RoZW1lLnNwYWNpbmcoMil9O1xuICAgICAgICBoZWlnaHQ6IDI1MHB4O1xuICAgIGAsXG4gICAgZW1wdHlTdGF0ZToge1xuICAgICAgICBtYXhIZWlnaHQ6IDI1MFxuICAgIH0sXG59O1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzc2VzOyJdfQ== */"),
  emptyState: {
    maxHeight: 250
  }
};
var _default = classes;
exports.default = _default;